var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewWhiteLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 853.61 240.51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ae0c21;\n      }\n\n      .cls-1, .cls-2 {\n        fill-rule: evenodd;\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        stroke-width: 0px;\n      }\n\n      .cls-2, .cls-3 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M853.61,129.61v9.15c0,1.83-.91,1.83-1.83,1.83h-12.81s0,51.24,0,51.24c0,1.83-.91,1.83-1.83,1.83h-10.98c-.91,0-1.83,0-1.83-1.83v-51.24h-12.81c-.92,0-1.83,0-1.83-1.83v-9.15c0-1.83.91-1.83,1.83-1.83h40.26c.92,0,1.83,0,1.83,1.83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M414.08,95.89c0,.66.51,1.2,1.17,1.26,32.73,2.66,58.46,30.05,58.46,63.46,0,7.93-1.46,15.51-4.11,22.51-.22.58,0,1.23.55,1.54l11.94,6.9c.67.38,1.54.1,1.83-.61,3.86-9.36,6-19.6,6-30.34,0-42.23-32.94-76.92-74.47-79.71h-.07s-.03,0-.03,0c-.69,0-1.27.59-1.27,1.29v13.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M349.91,184.66c.54-.31.77-.96.55-1.54-2.65-7-4.11-14.58-4.11-22.51,0-33.41,25.73-60.8,58.46-63.46.66-.05,1.17-.59,1.17-1.26v-13.71c0-.71-.57-1.28-1.27-1.29h-.1c-41.53,2.8-74.47,37.48-74.47,79.71,0,10.74,2.14,20.98,6,30.34.3.71,1.16,1,1.83.61l11.94-6.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M466.84,192.11c-.61-.35-1.37-.13-1.73.47-11.03,18.97-31.56,31.72-55.08,31.72s-44.05-12.75-55.08-31.72c-.35-.61-1.12-.82-1.72-.47l-11.8,6.81c-.61.35-.83,1.15-.47,1.76,13.85,23.79,39.62,39.82,69.08,39.82s55.23-16.03,69.08-39.83c.36-.61.14-1.4-.47-1.76l-11.8-6.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M413.49,221.37v-59.87c0-.61.29-1.19.77-1.56,16.51-12.81,28.02-26.58,27.79-49.56,0-.81,1.14-.95,1.31-.16l10.08,46.92c.25,1.18.04,2.4-.6,3.42l-37.97,61.19c-.4.64-1.38.36-1.38-.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M405.83,221.37v-59.87c0-.61-.29-1.19-.77-1.56-16.51-12.81-28.02-26.58-27.79-49.56,0-.81-1.14-.95-1.31-.16l-10.08,46.92c-.25,1.18-.04,2.4.59,3.42l37.97,61.19c.4.64,1.38.36,1.38-.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M355.98,168.36c1.03.64-.68,2.15-1.72,2.14.03-1.26,1.31-1.26,1.72-2.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M427.22,88.54c3.84-1.44,1.66,6.27-1.29,4.29-1.94-1.3.52-4,1.29-4.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M398.04,97.56c2.53-2.04,1.77,5.07-.43,3.86-1.58-.86.15-3.64.43-3.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M430.65,99.7c1.88-.15,5.44.24,3.86,4.72-.85,2.42-1.89.74-3.86,2.58-1.03.96-1.44,2.74-3.43,2.57-6.39-.54-1.89-9.46,3.43-9.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M446.1,101.85c1.89-1.35.26,3.7-.86,2.58-1.24-1.24.48-2.3.86-2.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M426.79,110.43c2.27-1.17,1.37,2.48-.43,1.71-1.19-.5-.02-1.49.43-1.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M413.91,111.72c1.81-1.81.97,1.96,0,1.72-1-.25-.49-1.23,0-1.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M386.45,117.73c1.59-1.59.63,2.35-.43,1.29-.49-.49.36-1.22.43-1.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M359.84,130.6c2.49-1.46-.15,4.29-1.29,3-1.48-1.66.8-2.72,1.29-3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M473.56,131.46c1.9-1.3.13,2.7-.86,1.72-.79-.79.34-1.36.86-1.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M392.42,203.15c2.33-1.71.55,4.42-.86,3-1.12-1.12.83-2.98.86-3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M389.88,133.6c4.15-3.12,2.63,6.45-.43,4.29-1.61-1.13-.13-3.87.43-4.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M382.16,134.46c4.47-1.05,1.02,7.56-1.71,5.58-2.28-1.64.47-5.29,1.71-5.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M404.9,134.46c3.12-2.24,2.51,4.76-.43,3-1.3-.78-.24-2.53.43-3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M378.72,134.46c.78,1.09-1.54,2.73-2.58,3.43.2-1.81,2.03-1.98,2.58-3.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M382.98,205.3c6.87-1.72,2.74,12-2.58,8.58-3.17-2.04.78-8.13,2.58-8.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M366.71,141.33c-.36-.08-1.51.23-1.72.42-3.53,3.23-4.91,8.04-8.16,13.3-3.3,5.35-8.08,11.19-11.71,14.8.02.27.04.53.05.8,2.05-2.67,6.1-5.55,7.8-7.88,2.33-3.17,4.65-6.92,7.3-10.3,1.74-2.22,7.8-10.87,6.44-11.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M430.65,141.33s-.04-.42,0-.43c2.78-.62-2.19,2.62,0,.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M474.42,152.06c1.66-.94-.85,3.53-1.29,3-.75-.89.35-2.46,1.29-3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M470.13,156.35c1.72-1.78.7,2.85-.43,1.72-.37-.38.34-1.63.43-1.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M365.85,158.07c.87.48-.72,2.11-1.72,2.14.03-1.26,1.31-1.26,1.72-2.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M430.22,161.07c0-.83,2.15-.44,1.29.43-.4.4-1.29-.21-1.29-.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M453.39,160.64c.96.31.21,2.45-.86,2.15.44-.56.42-1.58.86-2.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M362.42,162.36c-1.19,2.12-3.69,3.14-3.43,5.58-2.03-2.38,1.56-4.48,3.43-5.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M387.74,163.21c1.81-1.41.21,2.78-.86,1.72-.38-.38.42-1.37.86-1.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M447.38,173.51c.45-2.76-1-1.63-2.14-3.01-2.68-3.2,2.38-6.79,4.29-4.29,1.59,2.08-1.35,4.32-2.15,7.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M467.12,177.37c4.01-1.8,3.38,6.06,1.29,6.87-3.43,1.33-4.44-5.44-1.29-6.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M379.58,178.23c-.43,2.14-2.73,2.42-4.29,3.43-.16-2.74,3.16-1.99,4.29-3.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M412.2,182.1c.2,1.35-1.15,1.13-1.29,2.14-1.5-.22-.4-2.58,1.29-2.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M403.18,185.53c2.12-.62,1.15,3.86-.86,3.43-.7-.15-.48-3.04.86-3.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M442.24,195.83c1.2-1.2-1.69,1.69,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M395.89,145.19c.37.42-.47,8.42-3.86,7.3-2.25-.75-.52-7.98,3.86-7.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M105.24,127.8h-36.58c-.91,0-1.83,0-1.83,1.83v62.19c0,1.83.92,1.83,1.83,1.83h36.58c.92,0,1.83,0,1.83-1.83v-9.15c0-1.83-.91-1.83-1.83-1.83h-23.78v-13.72h22.86c.91,0,1.83,0,1.83-1.83v-9.15c0-1.83-.92-1.83-1.83-1.83h-22.86v-13.72h23.78c.92,0,1.83,0,1.83-1.83v-9.15c0-1.83-.91-1.83-1.83-1.83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M165.7,127.8h-10.52c-1.37,0-2.1,0-2.38,1.83l-8.6,51.21h-1.83l-8.51-51.21c-.27-1.83-1.1-1.83-2.47-1.83h-10.52c-1.37,0-2.2,0-1.83,1.83l10.33,62.19c.28,1.83,1.1,1.83,2.47,1.83h22.96c1.37,0,2.1,0,2.38-1.83l10.43-62.19c.27-1.83-.55-1.83-1.92-1.83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M193.32,127.8h-10.98c-.91,0-1.83,0-1.83,1.83v62.19c0,1.83.92,1.83,1.83,1.83h10.98c.91,0,1.83,0,1.83-1.83v-62.19c0-1.83-.92-1.83-1.83-1.83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M250.03,180.84h-23.78v-51.21c0-1.83-.92-1.83-1.83-1.83h-10.98c-.91,0-1.83,0-1.83,1.83v62.19c0,1.83.92,1.83,1.83,1.83h36.58c.91,0,1.83,0,1.83-1.83v-9.15c0-1.83-.92-1.83-1.83-1.83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M301.25,146.75v-7.98c0-10.97-7.31-10.97-16.46-10.97h-10.98c-9.14,0-16.46,0-16.46,10.97v10.97c0,11.89,1.83,12.53,16.46,16.19l10.98,2.74c1.83.46,1.83,1.19,1.83,3.02v7.32c0,1.83-.92,1.83-1.83,1.83h-10.98c-.91,0-1.83,0-1.83-1.83v-8.66l-14.63,3.92v8.4c0,10.97,7.31,10.97,16.46,10.97h10.98c9.15,0,16.46,0,16.46-10.97v-10.97c0-11.89-1.83-12.53-16.46-16.19l-10.98-2.74c-1.83-.46-1.83-1.19-1.83-3.02v-7.31c0-1.83.92-1.83,1.83-1.83h10.98c.91,0,1.83,0,1.83,1.83v8.24l14.63-3.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M34.81,127.8H0l7.37,12.81v51.2c0,1.83.92,1.83,1.83,1.83h25.61c9.15,0,16.46,0,16.46-10.97v-43.9c0-10.97-7.32-10.97-16.46-10.97M36.63,179.01c0,1.83-.91,1.83-1.83,1.83h-12.8v-40.24h12.8c.92,0,1.83,0,1.83,1.83v36.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M696.48,172.26v6.75c0,1.83-.92,1.83-1.83,1.83h-10.98c-.91,0-1.83,0-1.83-1.83v-36.58c0-1.83.91-1.83,1.83-1.83h10.98c.91,0,1.83,0,1.83,1.83v10.86l14.63-3.92v-10.6c0-10.97-7.32-10.97-16.46-10.97h-10.98c-9.15,0-16.46,0-16.46,10.97v43.9c0,10.98,7.31,10.98,16.46,10.98h10.98c9.14,0,16.46,0,16.46-10.98v-14.33l-14.63,3.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M549.25,172.26v6.75c0,1.83-.92,1.83-1.83,1.83h-10.97c-.92,0-1.83,0-1.83-1.83v-36.58c0-1.83.91-1.83,1.83-1.83h10.98c.91,0,1.83,0,1.83,1.83v10.86l14.63-3.92v-10.6c0-10.97-7.32-10.97-16.46-10.97h-10.97c-9.15,0-16.46,0-16.46,10.97v43.9c0,10.98,7.32,10.98,16.46,10.98h10.98c9.14,0,16.46,0,16.46-10.98v-14.33l-14.63,3.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M591.76,191.81c0,1.83-.92,1.83-1.83,1.83h-10.98c-.91,0-1.83,0-1.83-1.83v-62.19c0-1.83.92-1.83,1.83-1.83h10.98c.91,0,1.83,0,1.83,1.83v62.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M770.11,129.62v53.04c0,10.98-7.32,10.98-16.47,10.98h-10.97c-9.15,0-16.47,0-16.47-10.98v-53.04c0-1.83.92-1.83,1.83-1.83h10.98c.91,0,1.83,0,1.83,1.83v49.38c0,1.83.91,1.83,1.83,1.83h10.97c.92,0,1.83,0,1.83-1.83v-49.38c0-1.83.91-1.83,1.83-1.83h10.98c.91,0,1.83,0,1.83,1.83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M800.76,191.81c0,1.83-.92,1.83-1.83,1.83h-10.98c-.91,0-1.83,0-1.83-1.83v-62.19c0-1.83.91-1.83,1.83-1.83h10.98c.91,0,1.83,0,1.83,1.83v62.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M652.85,191.81l-6.67-20.12c3.66-1.19,5.94-3.93,5.94-10.06v-22.86c0-10.97-7.32-10.97-16.46-10.97h-25.61c-.91,0-1.83,0-1.83,1.83v62.19c0,1.83.92,1.83,1.83,1.83h10.98c.91,0,1.83,0,1.83-1.83v-51.21h12.8c.92,0,1.83,0,1.83,1.83v15.55c0,1.83-.91,1.83-1.83,1.83h-8.85s10.68,32.01,10.68,32.01c.55,1.83,1.37,1.83,2.74,1.83h10.97c.91,0,2.29,0,1.65-1.83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M89.41,0c-8.39,7.45-17.95,13-28.18,17.48l36.42,26.1-2.05.99-15.08-10.03c-4.91-3.26-17.1-1-19.55,3.15l28.04,19.63c7.76-7.47,17.26-13.4,28.32-17.9l-36.84-25.67,1.96-1.53,11.93,8.54c5.95,4.26,10.68,5.38,23.5-.92L89.41,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "146.51 14.32 162.45 14.32 167.14 30.97 167.22 30.97 171.92 14.32 187.85 14.32 187.85 42.97 177.57 42.97 177.57 22.51 177.49 22.51 171.47 42.97 162.89 42.97 156.87 22.51 156.78 22.51 156.78 42.97 146.51 42.97 146.51 14.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M208.47,22.99h-.08l-3.37,9.71h6.82l-3.37-9.71ZM201.49,14.32h13.88l12.21,28.65h-12.04l-1.2-3.29h-11.8l-1.21,3.29h-12.04l12.2-28.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M266.6,14.32h11.32v17.34c0,3.69,2.12,4.85,5.82,4.85s5.82-1.16,5.82-4.85V14.32h11.32v17.78c0,9.11-5.5,11.88-17.14,11.88s-17.14-2.77-17.14-11.88V14.32Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "313.63 21.55 303.16 21.55 303.16 14.32 335.43 14.32 335.43 21.55 324.95 21.55 324.95 42.97 313.63 42.97 313.63 21.55"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 337.81,
    y: 14.32,
    width: 11.32,
    height: 28.65
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M240.06,21.55h7.87c1.89,0,3.29.52,3.29,2.69,0,1.8-.92,2.69-3.13,2.69h-8.03v-5.38ZM265.97,42.97l-9.63-8.96c7.93-1.25,6.92-9.04,6.92-11.7,0-3.13-1.76-5.9-3.89-6.94-1.57-.76-3.53-1.04-6.79-1.04h-23.84v28.65h11.32v-8.83h1.97l9.47,8.83h14.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M386.01,30.81c-5.54-.84-7.83-4.05-7.83-8.06,0-7.43,7.27-9.43,16.57-9.43,12.76,0,18.02,3.33,18.42,9.39h-13.16c0-1.16-.68-1.89-1.73-2.29-1-.44-2.28-.6-3.53-.6-3.37,0-4.53.84-4.53,2.05,0,.8.36,1.32,1.49,1.48l13.52,2.01c5.7.84,9.24,3.49,9.24,8.35,0,6.98-5.7,10.27-18.42,10.27-8.71,0-18.22-1.2-18.26-9.63h13.65c.04.97.4,1.61,1.2,2.05.84.4,2.09.6,3.85.6,3.53,0,4.49-.96,4.49-2.33,0-.85-.52-1.68-2.05-1.93l-12.92-1.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M417.59,14.32h11.32v17.34c0,3.69,2.13,4.85,5.82,4.85s5.82-1.16,5.82-4.85V14.32h11.32v17.78c0,9.11-5.5,11.88-17.14,11.88s-17.14-2.77-17.14-11.88V14.32Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "454.92 36.91 472.09 21.55 456.08 21.55 456.08 14.32 487.33 14.32 487.33 20.58 470.56 35.75 486.9 35.75 486.9 42.97 454.92 42.97 454.92 36.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M490.39,14.32h11.32v17.34c0,3.69,2.13,4.85,5.82,4.85s5.82-1.16,5.82-4.85V14.32h11.32v17.78c0,9.11-5.5,11.88-17.13,11.88s-17.14-2.77-17.14-11.88V14.32Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 569.08,
    y: 14.32,
    width: 11.32,
    height: 28.65
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "529.6 42.98 540.6 42.98 540.39 32.7 551.41 42.98 565.87 42.98 550.15 28.35 566.7 14.32 552.95 14.32 540.6 24.25 540.6 14.32 529.6 14.32 529.6 42.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "689.27 39.52 689.27 29.78 711.88 29.78 711.88 26.37 689.27 26.37 689.27 17.77 714.8 17.77 714.8 14.32 685.4 14.32 685.4 42.97 715.08 42.97 715.08 39.52 689.27 39.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M774.86,14.33h-3.08l-18.38,28.64h4.62l5.43-8.53h19.35l5.31,8.53h4.52l-17.79-28.64ZM780.68,30.99h-14.97l7.63-11.79,7.34,11.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M630.5,14.33h-3.08l-18.38,28.64h4.62l5.43-8.53h19.35l5.31,8.53h4.52l-17.79-28.64ZM636.32,30.99h-14.97l7.63-11.79,7.34,11.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M747.98,14.32v23.3c-2.72-2.47-6.97-6.21-12.64-11.13-5.81-5.07-10.34-9.12-13.45-12.04l-.14-.13h-3.62v28.65h3.91v-23.39l26.19,23.39h3.66V14.32h-3.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M674.36,30.19c.68-.18,1.28-.37,1.81-.57,3.71-1.4,5.59-3.69,5.59-6.82,0-5.63-4.75-8.48-14.12-8.48h-17.82v28.64h3.92v-11.89h13.29c1.03,0,2.07-.05,3.22-.17l7.57,12.07h4.53l-7.99-12.78ZM674.56,26.54c-1.8.73-4.01,1.1-6.57,1.1h-14.27v-9.89h14.23c6.59,0,9.8,1.67,9.8,5.09,0,1.62-1.04,2.83-3.2,3.7Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewWhiteLogo);
export default __webpack_public_path__ + "static/media/newWhiteLogo.09d95267d29f4b6d38def6c2243b9906.svg";
export { ForwardRef as ReactComponent };